import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type BarKpiDataObject } from '../../types'

export interface TotalShippedState {
  isLoading: boolean
  error: boolean
  data: BarKpiDataObject | undefined
  httpStatus: number
}

const initialState: TotalShippedState = {
  isLoading: true,
  error: false,
  data: undefined,
  httpStatus: 0
}

const totalShippedSlice = createSlice({
  name: 'totalShipped',
  initialState,
  reducers: {
    totalShippedLoadingAction: (state) => {
      return {
        isLoading: true,
        error: false,
        data: undefined,
        httpStatus: 0
      }
    },
    totalShippedUpdateAction: (state, action: PayloadAction<{ data: BarKpiDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: false,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    totalShippedErrorAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: true,
        data: undefined,
        httpStatus: action.payload
      }
    }
  }
})

export const {
  totalShippedLoadingAction,
  totalShippedUpdateAction,
  totalShippedErrorAction
} = totalShippedSlice.actions

export default totalShippedSlice.reducer
